// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1PdvU","header":"MessagesList_header__3BHGU","chat":"MessagesList_chat__3bRnS"};